export default {
  captchaId: '2f53e962e99b89ef23757e3687be2459',
  product: 'bind'
}
